import React from 'react'
import style from './Namemenu.module.css'

const Namemenu = () => {
    return (

            <div className={style.header}>
                <div className={style.name}>N O U D &nbsp;V A N &nbsp;D U N</div>
            <div className={style.webdev}>web development art &#38; design</div>
            </div>
    )
}

export default Namemenu
